import React from "react"
import { UnstyledBlockContent, UnstyledBlockContentProps } from "@silversea-ssc/ui-components-react"
import ErrorBoundaryInline from "../ErrorBoundaryInline"

export type BlockContentProps = UnstyledBlockContentProps

const BlockContent: React.FC<React.PropsWithChildren<BlockContentProps>> = (props) => {
    return (
        <ErrorBoundaryInline>
            <UnstyledBlockContent {...props} />
        </ErrorBoundaryInline>
    )
}

export default BlockContent
